import { createSlice } from "@reduxjs/toolkit";
import { DAHBOARD_COUNTS } from "../constants";

const initialState = {
  transactionVolume: {
    totalVolume: 0,
    totalPayin: 0,
    totalPrefund: 0,
    totalPayout: 0,
    totalRefund: 0,
  },
  transactionCounts: {
    totalCount: 0,
    totalPayin: 0,
    payinSuccess: 0,
    payinFailure: 0,
    totalPayout: 0,
    payoutSuccess: 0,
    payoutFailure: 0,
    totalPrefund: 0,
    prefundSuccess: 0,
    prefundFailure: 0,
    totalVan: 0,
    totalVanCount: 0,
    vanSuccess: 0,
    vanFailure: 0,
  },
  settlementCount: {
    totalSettledAmount: 0,
    totalUnsettledAmount: 0,
    lastUpdatedTime: "",
  },
  mainTransactionVolume: {
    totalPayin: 0,
    totalPrefund: 0,
    totalPayout: 0,
  },
  lastUpdatedTime: "",
  roleCounts: {
    reselleCount: 0,
    clientCount: 0,
  },
  clientBalance: {
    count: 0,
    payoutCount: 0,
  },
  clientPayoutBalance: {
    count: 0,
  },
  clientVoucherBalance: {
    count: 0,
  },
  clearFilters: false,
};

export const dashboardCountSlice = createSlice({
  name: DAHBOARD_COUNTS,
  initialState,
  reducers: {
    transactionVolumeCountSlice: (state, action) => {
      const data = {
        ...state,
        transactionVolume: {
          totalVolume: action.payload.totalVolume,
          totalPayin: action.payload.totalPayin,
          totalPrefund: action.payload.totalPrefund,
          totalPayout: action.payload.totalPayout,
          totalVan: action.payload.totalVan,
          totalRefund: action.payload.totalRefund,
        },

        lastUpdatedTime: action.payload.lastUpdatedTime,
      };
      return (state = data);
    },

    transactionCountSlice: (state, action) => {
      const data = {
        ...state,
        transactionCounts: {
          payin: action.payload?.payin,
          payout: action.payload?.payout,
          prefund: action.payload?.prefund,
          van: action.payload?.van,
          // payinFailure: action.payload?.payinFailure,
          // totalPayout: action.payload?.totalPayout,
          // payoutSuccess: action.payload?.payoutSuccess,
          // payoutFailure: action.payload?.payoutFailure,
          // totalPrefund: action.payload?.totalPrefund,
          // prefundSuccess: action.payload?.prefundSuccess,
          // prefundFailure: action.payload?.prefundFailure,
        },
        lastUpdatedTime: action.payload.lastUpdatedTime,
      };
      return (state = data);
    },

    updateMainTransactionSlice: (state, action) => {
      const data = {
        ...state,
        mainTransactionVolume: {
          totalPayin: action.payload.totalPayin,
          totalPrefund: action.payload.totalPrefund,
          totalPayout: action.payload.totalPayout,
          totalVan: action.payload.totalVan,
        },
      };
      return (state = data);
    },
    settlementCountSlice: (state, action) => {
      const totalSettledAmount = Number(action.payload.totalSettledAmount) || 0;
      const clientVoucherBalance =
        Number(action.payload.clientVoucherBalance) || 0;

      const data = {
        ...state,
        settlementCount: {
          totalSettledAmount: action.payload.totalSettledAmount,
          totalUnsettledAmount: totalSettledAmount + clientVoucherBalance,
          lastUpdatedTime: action.payload.lastUpdated,
        },
      };
      return (state = data);
    },

    updateRoleCountsSlice: (state, action) => {
      const data = {
        ...state,
        roleCounts: {
          reselleCount: action.payload.resellerCount,
          clientCount: action.payload.clientCount,
        },
      };
      return (state = data);
    },

    updateClientBalanceSlice: (state, action) => {
      const data = {
        ...state,
        clientBalance: {
          count: action.payload,
        },
      };
      return (state = data);
    },
    updatePayoutClientBalanceSlice: (state, action) => {
      const data = {
        ...state,
        clientPayoutBalance: {
          count: action.payload,
        },
      };
      return (state = data);
    },
    updateClientVoucherBalanceSlice: (state, action) => {
      state.clientVoucherBalance = {
        count: action.payload,
      };
    },

    clearClientBalanceSlice: (state, action) => {
      const data = {
        ...state,
        clientBalance: {
          count: 0,
        },
      };
      return (state = data);
    },

    clearPayoutClientBalanceSlice: (state, action) => {
      const data = {
        ...state,
        clientPayoutBalance: {
          count: 0,
        },
      };
      return (state = data);
    },

    clearVoucherClientBalanceSlice: (state, action) => {
      state.clientVoucherBalance = { ...initialState.clientVoucherBalance };
    },

    clearDashboardFilter: (state, action) => {
      const data = {
        ...state,
        clearFilters: action.payload,
      };
      return (state = data);
    },
  },
});

export const {
  transactionVolumeCountSlice,
  updateMainTransactionSlice,
  transactionCountSlice,
  updateRoleCountsSlice,
  settlementCountSlice,
  updateClientBalanceSlice,
  clearClientBalanceSlice,
  clearDashboardFilter,
  updatePayoutClientBalanceSlice,
  clearPayoutClientBalanceSlice,
  updateClientVoucherBalanceSlice,
  clearVoucherClientBalanceSlice,
} = dashboardCountSlice.actions;

export default dashboardCountSlice.reducer;
